import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="bg-cream-50">
      <div className="section flex min-h-[50vh] flex-col items-center justify-center text-center">
        <p className="eyebrow">404</p>
        <h1 className="mt-4 font-serif text-4xl text-sage-800 sm:text-5xl">
          We couldn't find that page.
        </h1>
        <p className="mt-5 max-w-md text-sage-700/90">
          The page you're looking for may have moved or no longer exists. Let's
          get you back on track.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link to="/" className="btn-primary">
            Back to home
          </Link>
          <Link to="/#contact" className="btn-secondary">
            Contact us
          </Link>
        </div>
      </div>
    </section>
  );
}
